import type { Configuration } from "@azure/msal-browser";

const defaultRedirectUri = typeof window !== "undefined" ? window.location.origin : "";

export const msalConfig: Configuration = {
    auth: {
        clientId: import.meta.env.VITE_MSAL_CLIENT_ID,
        authority: `https://login.microsoftonline.com/${import.meta.env.VITE_MSAL_TENANT_ID}`,
        redirectUri: import.meta.env.VITE_MSAL_REDIRECT_URI || defaultRedirectUri,
    },
    cache: {
        cacheLocation: "localStorage",
        // @ts-ignore - storeAuthStateInCookie is supported in MSAL Browser 3+ but may be missing from strict types
        storeAuthStateInCookie: true,
    },
};

export const apiRequest = {
    scopes: import.meta.env.VITE_API_SCOPE ? import.meta.env.VITE_API_SCOPE.split(" ") : [],
};

export const graphRequest = {
    scopes: ["openid", "profile", "offline_access", "user.read"],
};

export const loginRequest = {
    scopes: [...graphRequest.scopes],
};
